// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact .custom-container .content-section {
  background: #E0E7FF;
  padding: 4rem 1rem;
  min-height: 55vh;
}
.contact .custom-container .content-section .page-title {
  font-size: 2.2rem;
  text-align: center;
  color: #08245A;
}
.contact .custom-container .content-section .page-title::after {
  content: "";
  display: block;
  height: 8px;
  width: 60px;
  background: #08245A;
  margin: 0.7rem auto 0;
  border-radius: 20px;
}
.contact .custom-container .content-section .content-body {
  max-width: 900px;
  margin: 3rem auto 0;
  border-radius: 3px;
}
.contact .custom-container .content-section .content-body .custom-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
  background: #fff;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.contact .custom-container .content-section .content-body .custom-card .left {
  padding: 0;
  margin-right: 1.5rem;
}
.contact .custom-container .content-section .content-body .custom-card .left img {
  height: 70px;
  width: 70px;
  object-fit: cover;
  border-radius: 100%;
}
.contact .custom-container .content-section .content-body .custom-card .right {
  flex: 1 1;
  position: relative;
}
.contact .custom-container .content-section .content-body .custom-card .right .copy-email-btn {
  border: none;
  background: transparent;
  color: rgb(11, 133, 255);
  padding: 0;
  word-break: break-all;
  text-align: left;
  margin-top: 0.5rem;
}
.contact .custom-container .content-section .content-body .custom-card .right .copy-email-btn:focus {
  outline: none;
}
@media (min-width: 576px) {
  .contact .custom-container .content-section .content-body .custom-card {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
}

.tooltipText {
  visibility: hidden;
  width: 215px;
  background-color: #23282d;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 10px 5px;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  margin-top: -35px;
  left: 0px;
  opacity: 0.9;
}

.copy-email-btn:hover + .tooltipText {
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/pages/contact/style.scss","webpack://./src/assets/css/common/_variables.scss"],"names":[],"mappings":"AAKI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AAJN;AAMM;EACE,iBCEK;EDDL,kBAAA;EACA,cAAA;AAJR;AAMQ;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAJV;AAQM;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AANR;AAQQ;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,2CAAA;AANV;AAOU;EACE,UAAA;EACA,oBAAA;AALZ;AAOY;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AALd;AAQU;EACE,SAAA;EACA,kBAAA;AANZ;AAQY;EACE,YAAA;EACA,uBAAA;EACA,wBAAA;EACA,UAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AANd;AAQc;EACE,aAAA;AANhB;AAWU;EAxCF;IAyCI,mBAAA;IACA,2BAAA;IACA,mBAAA;EARV;AACF;;AAeA;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF","sourcesContent":["@import \"./src/assets/css/common/variables\";\r\n\r\n.contact {\r\n\r\n  .custom-container {\r\n    .content-section {\r\n      background: #E0E7FF;\r\n      padding: 4rem 1rem;\r\n      min-height: 55vh;\r\n\r\n      .page-title {\r\n        font-size: $page-title;\r\n        text-align: center;\r\n        color: #08245A;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          display: block;\r\n          height: 8px;\r\n          width: 60px;\r\n          background: #08245A;\r\n          margin: .7rem auto 0;\r\n          border-radius: 20px;\r\n        }\r\n      }\r\n\r\n      .content-body {\r\n        max-width: 900px;\r\n        margin: 3rem auto 0;\r\n        border-radius: 3px;\r\n\r\n        .custom-card {\r\n          display: flex;\r\n          flex-direction: column;\r\n          justify-content: center;\r\n          align-items: center;\r\n          margin-bottom: 1.5rem;\r\n          background: #fff;\r\n          padding: 1.5rem;\r\n          border-radius: 12px;\r\n          box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n          .left {\r\n            padding: 0;\r\n            margin-right: 1.5rem;\r\n\r\n            img{\r\n              height: 70px;\r\n              width: 70px;\r\n              object-fit: cover;\r\n              border-radius: 100%;\r\n            }\r\n          }\r\n          .right {\r\n            flex: 1;\r\n            position: relative;\r\n\r\n            .copy-email-btn {\r\n              border: none;\r\n              background: transparent;\r\n              color: rgb(11, 133, 255);\r\n              padding: 0;\r\n              word-break: break-all;\r\n              text-align: left;\r\n              margin-top: .5rem;\r\n\r\n              &:focus {\r\n                outline: none;\r\n              }\r\n            }\r\n          }\r\n\r\n          @media (min-width: 576px) {\r\n            flex-direction: row;\r\n            justify-content: flex-start;\r\n            align-items: center;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.tooltipText {\r\n  visibility: hidden;\r\n  width: 215px;\r\n  background-color: #23282d;\r\n  color: #fff;\r\n  text-align: center;\r\n  border-radius: 6px;\r\n  padding: 10px 5px;\r\n\r\n  /* Position the tooltip */\r\n  position: absolute;\r\n  z-index: 1;\r\n  margin-top: -35px;\r\n  left: 0px;\r\n  opacity: 0.9;\r\n}\r\n\r\n.copy-email-btn:hover + .tooltipText {\r\n  visibility: visible;\r\n}\r\n","// Color palette\r\n$color-blue-light: #d0dbff;\r\n$color-blue: #354e80;\r\n$color-blue-dark: #1c2f56;\r\n\r\n$color-sky: #e0e7ff;\r\n\r\n$color-yellow-light: #fffdef;\r\n$color-yellow: #fae205;\r\n\r\n$color-black-30: #e1e2e2;\r\n\r\n$section-heading-font-size: 2.1rem;\r\n$page-title: 2.2rem;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
